<template>
  <TemplateHead />
  <Toast />
  <ConfirmDialog />
  <LoadingOverlay />

  <CassemsConvitePesquisa />

  <div
    class="layout-wrapper"
    :class="{ 'sidebar-aberta': menuAberto, 'sidebar-recolhida': menuRecolhido }"
  >
    <aside class="layout-sidebar" id="menu-lateral" aria-label="Navegação principal">
      <!-- Logo Cassems. É o MESMO arquivo que roda em produção no legado: o c-conecte
           sobrescreve o logo do tema Ultima em layout-custom.css:19 apontando para
           resources/imagens/logo.png. Copiado de
           E:/cassems/sisgs-core-template-jsf-pf-ultima/src/main/webapp/resources/imagens/. -->
      <div class="sidebar-logo">
        <img src="@/assets/imagens/logo-cassems.png" alt="CASSEMS" width="200" height="30" />
      </div>

      <!-- Menu (O perfil já é renderizado dentro do AppMenu se profileMode for 'inline') -->
      <AppMenu />
    </aside>

    <!-- Botão de recolher/expandir o menu, como no legado: disco rosa com seta, colado na emenda
         da sidebar com o conteúdo. Mora aqui, e não na topbar, porque precisa ficar POR CIMA das
         duas — na topbar ele não teria como cruzar a fronteira. -->
    <button
      type="button"
      class="sidebar-toggle"
      :aria-label="rotuloBotaoMenu"
      :title="rotuloBotaoMenu"
      aria-controls="menu-lateral"
      :aria-expanded="menuVisivel"
      @click="alternarMenu"
    >
      <i :class="menuVisivel ? 'pi pi-angle-left' : 'pi pi-angle-right'" aria-hidden="true" />
    </button>

    <div class="layout-container">
      <Topbar @usuario-carregado="nomeUsuario = $event" />

      <main class="layout-main">
        <!-- A `key` força remontagem quando o caminho muda. Sem ela, duas rotas que apontam para
             o MESMO componente (Solicitar Autorização × Transcrição SP/SADT, e o par de
             internação) reaproveitariam a instância: quem preenchesse metade de uma solicitação e
             fosse para a transcrição pelo menu encontraria o formulário ainda preenchido.
             Também faz as telas de detalhe recarregarem ao trocar o :id, que é o que elas esperam
             — todas carregam os dados no onMounted. -->
        <RouterView :key="route.fullPath" />
      </main>

      <AppFooter />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import AppMenu from './views/menu/menu.vue'
import AppFooter from './views/footer/footer.vue'
import Topbar from './views/topbar/topbar.vue'
import TemplateHead from './views/template-head-default/template-head-default.vue'
import LoadingOverlay from './components/common/LoadingOverlay.vue'
import CassemsConvitePesquisa from './components/common/CassemsConvitePesquisa.vue'

const nomeUsuario = ref('')

/**
 * O menu tem dois comportamentos e por isso dois estados — não é duplicação:
 * no desktop ele está sempre presente e o botão o RECOLHE (largura vai a zero);
 * abaixo de 1024px ele é uma gaveta fora do fluxo e o botão a ABRE.
 * Um estado só teria que significar "aberto" de um lado e "fechado" do outro no mesmo boolean.
 */
const menuAberto = ref(false)      // gaveta (≤1024px)
const menuRecolhido = ref(false)   // sidebar fixa (>1024px)

/* O mesmo 1024px do @media do style.css. É um `ref` alimentado por listener, e não uma leitura
   direta dentro do computed, porque `matchMedia(...).matches` não é reativo: ao redimensionar a
   janela a seta ficaria apontando para o lado errado até o próximo clique. */
const consulta = window.matchMedia('(max-width: 1024px)')
const ehMobile = ref(consulta.matches)
consulta.addEventListener('change', (e) => { ehMobile.value = e.matches })

/** O menu está à vista? É o que decide a direção da seta e o rótulo, nos dois modos. */
const menuVisivel = computed(() => (ehMobile.value ? menuAberto.value : !menuRecolhido.value))

const rotuloBotaoMenu = computed(() =>
  menuVisivel.value ? 'Recolher menu de navegação' : 'Expandir menu de navegação'
)

const alternarMenu = () => {
  if (ehMobile.value) menuAberto.value = !menuAberto.value
  else menuRecolhido.value = !menuRecolhido.value
}

const route = useRoute()

// Navegar fecha a gaveta: sem isso o overlay continua cobrindo a tela recém-aberta.
// Só a gaveta — recolher no desktop é uma preferência do usuário, não deve se desfazer sozinho.
watch(() => route.fullPath, () => { menuAberto.value = false })
</script>
